import { useTranslation } from 'react-i18next'
import React from 'react'

import Select from '../../../packages/kiti/components/form/Select'

export const AVAILABILITY_STATUSES = ['available', 'unavailable']

const AvailabilityStatusSelect = ({ ...props }) => {
  const { t } = useTranslation('availability')

  const options = AVAILABILITY_STATUSES.map(id => ({ id, name: t(`status.${id}`) }))

  // Without `selectOnlyId`, Select/Picker hand back the whole `{ id, name }` option
  // object instead of the plain "available"/"unavailable" string. Every caller here
  // (ChangeAvailabilityStatusForm, the automation action sentence) treats the field
  // value as that raw string, so this must stay a plain id.
  return <Select options={options} disableEmptyOption selectOnlyId {...props} />
}

export default AvailabilityStatusSelect
